import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function AssinarContrato() {
  const estiloImpressao = `
    @media print {
      body * { visibility: hidden !important; }
      #contrato-print, #contrato-print * { visibility: visible !important; }
      #contrato-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; padding: 20px !important; }
      button, .no-print { display: none !important; }
    }
  `;
  const { token } = useParams();
  const [contrato, setContrato] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [nomeAssinante, setNomeAssinante] = useState('');
  const [cpfAssinante, setCpfAssinante] = useState('');
  const [foto, setFoto] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [assinando, setAssinando] = useState(false);
  const [assinado, setAssinado] = useState(false);
  const [dadosAssinatura, setDadosAssinatura] = useState(null);
  const inputFotoRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/contratos/publico/${token}`)
      .then(r => { setContrato(r.data); setLoading(false); })
      .catch(() => { setErro('Contrato não encontrado ou link inválido.'); setLoading(false); });
  }, [token]);

  const formatarCPF = (v) => {
    const nums = v.replace(/\D/g, '').substring(0, 11);
    return nums.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
               .replace(/(\d{3})(\d{3})(\d{3})/, '$1.$2.$3')
               .replace(/(\d{3})(\d{3})/, '$1.$2')
               .replace(/(\d{3})/, '$1');
  };

  const selecionarFoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFoto(file);
    const reader = new FileReader();
    reader.onload = (ev) => setFotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const tirarFoto = () => {
    inputFotoRef.current.click();
  };

  const assinar = async () => {
    if (!nomeAssinante.trim()) { alert('Digite seu nome completo.'); return; }
    if (!cpfAssinante || cpfAssinante.replace(/\D/g, '').length < 11) { alert('Digite um CPF válido.'); return; }
    if (!foto) { alert('Tire uma foto do seu documento (RG ou CNH) para continuar.'); return; }
    if (!window.confirm(`Confirma a assinatura como "${nomeAssinante}" — CPF ${cpfAssinante}?`)) return;

    setAssinando(true);
    try {
      const formData = new FormData();
      formData.append('nome_assinante', nomeAssinante);
      formData.append('cpf_assinante', cpfAssinante);
      formData.append('foto_documento', foto);

      const res = await axios.post(`${API}/contratos/assinar/${token}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setDadosAssinatura({
        hash: res.data.hash,
        nome: nomeAssinante,
        cpf: cpfAssinante,
        data: new Date().toLocaleString('pt-BR'),
        token,
        foto_salva: res.data.foto_salva
      });
      setAssinado(true);
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao assinar contrato');
    }
    setAssinando(false);
  };

  const baixarPDF = () => window.print();
  const cor = contrato?.cor_primaria || '#1D9E75';

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ textAlign: 'center' }}><div style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</div><div style={{ color: '#666' }}>Carregando contrato...</div></div>
    </div>
  );

  if (erro) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ textAlign: 'center', background: 'white', borderRadius: '16px', padding: '40px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
        <div style={{ color: '#A32D2D', fontWeight: '600' }}>{erro}</div>
      </div>
    </div>
  );

  if (assinado && dadosAssinatura) return (
    <>
    <style>{estiloImpressao}</style>
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: '20px' }}>
      <div id="contrato-print" style={{ maxWidth: '700px', margin: '0 auto' }}>
        <div style={{ background: cor, padding: '16px 24px', borderRadius: '12px 12px 0 0', display: 'flex', alignItems: 'center', gap: '12px' }}>
          {contrato.logo_url && <img src={contrato.logo_url} alt="Logo" style={{ height: '36px', objectFit: 'contain' }} />}
          <span style={{ color: 'white', fontWeight: '700', fontSize: '16px' }}>{contrato.tenant_nome}</span>
        </div>
        <div style={{ background: 'white', padding: '32px', borderRadius: '0 0 12px 12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <div style={{ fontSize: '64px', marginBottom: '12px' }}>✅</div>
            <h2 style={{ color: '#0F6E56', margin: '0 0 8px' }}>Contrato Assinado com Sucesso!</h2>
            <p style={{ color: '#666', margin: 0 }}>Guarde as informações abaixo como comprovante.</p>
          </div>

          <div style={{ background: '#f8f8f8', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#666', textTransform: 'uppercase', letterSpacing: '1px' }}>📋 Comprovante de Assinatura Digital</h3>
            <div style={{ display: 'grid', gap: '12px' }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                <span style={{ fontSize: '18px', minWidth: '24px' }}>👤</span>
                <div><div style={{ fontSize: '11px', color: '#999', fontWeight: '600' }}>ASSINADO POR</div><div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>{dadosAssinatura.nome}</div></div>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <span style={{ fontSize: '18px', minWidth: '24px' }}>🪪</span>
                <div><div style={{ fontSize: '11px', color: '#999', fontWeight: '600' }}>CPF</div><div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>{dadosAssinatura.cpf}</div></div>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <span style={{ fontSize: '18px', minWidth: '24px' }}>📅</span>
                <div><div style={{ fontSize: '11px', color: '#999', fontWeight: '600' }}>DATA E HORA</div><div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>{dadosAssinatura.data}</div></div>
              </div>
              {dadosAssinatura.foto_salva && (
                <div style={{ display: 'flex', gap: '12px' }}>
                  <span style={{ fontSize: '18px', minWidth: '24px' }}>📸</span>
                  <div><div style={{ fontSize: '11px', color: '#999', fontWeight: '600' }}>DOCUMENTO</div><div style={{ fontSize: '14px', color: '#0F6E56', fontWeight: '600' }}>✅ Foto do documento registrada</div></div>
                </div>
              )}
              <div style={{ display: 'flex', gap: '12px' }}>
                <span style={{ fontSize: '18px', minWidth: '24px' }}>🔒</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '11px', color: '#999', fontWeight: '600' }}>CÓDIGO DE VERIFICAÇÃO (SHA-256)</div>
                  <div style={{ fontSize: '11px', fontFamily: 'monospace', color: '#333', wordBreak: 'break-all', background: 'white', padding: '8px', borderRadius: '6px', marginTop: '4px', border: '1px solid #eee' }}>{dadosAssinatura.hash}</div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '16px', padding: '12px', background: '#E1F5EE', borderRadius: '8px', fontSize: '12px', color: '#0F6E56' }}>
              ℹ️ Assinatura válida conforme Lei nº 14.063/2020. Nome, CPF, IP, foto do documento e hash SHA-256 foram registrados como prova.
            </div>
          </div>

          <button className='no-print' onClick={baixarPDF} style={{ width: '100%', background: cor, color: 'white', border: 'none', borderRadius: '8px', padding: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
            📄 Baixar Contrato em PDF
          </button>
        </div>
      </div>
    </div>
    </>
  );

  const renderConteudo = (texto) => {
    return texto
      .replace(/^# (.+)$/gm, '<h1 style="font-size:22px;color:#1D3557;margin:24px 0 12px">$1</h1>')
      .replace(/^## (.+)$/gm, '<h2 style="font-size:18px;color:#1D3557;margin:20px 0 8px">$1</h2>')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/^- (.+)$/gm, '<li style="margin:4px 0">$1</li>')
      .replace(/---/g, '<hr style="border:1px solid #eee;margin:20px 0"/>')
      .replace(/\n\n/g, '</p><p style="margin:8px 0">')
      .replace(/\n/g, '<br/>');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: cor, padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '16px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        {contrato.logo_url && <img src={contrato.logo_url} alt="Logo" style={{ height: '40px', objectFit: 'contain' }} />}
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>{contrato.tenant_nome}</span>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '24px' }}>

        {/* Status */}
        {contrato.status === 'assinado' ? (
          <div style={{ background: '#E1F5EE', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <span style={{ fontSize: '28px' }}>✅</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '700', color: '#0F6E56', fontSize: '16px', marginBottom: '8px' }}>Contrato Assinado</div>
                <div style={{ display: 'grid', gap: '6px', fontSize: '13px', color: '#333' }}>
                  <div>👤 <strong>Assinado por:</strong> {contrato.assinado_por}</div>
                  {contrato.cpf_assinante && <div>🪪 <strong>CPF:</strong> {contrato.cpf_assinante}</div>}
                  <div>📅 <strong>Data/hora:</strong> {new Date(contrato.assinado_em).toLocaleString('pt-BR')}</div>
                  <div>🌐 <strong>IP do dispositivo:</strong> {contrato.ip_assinatura}</div>
                  {contrato.foto_documento && (
                    <div>
                      <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', marginBottom: '6px', marginTop: '8px' }}>📸 FOTO DO DOCUMENTO:</div>
                      <img src={`https://b3rastreamento.com.br${contrato.foto_documento}`} alt="Documento" style={{ maxWidth: '250px', borderRadius: '8px', border: '2px solid #cce5cc' }} />
                    </div>
                  )}
                  <div style={{ marginTop: '8px' }}>
                    <div style={{ fontSize: '11px', color: '#666', fontWeight: '600', marginBottom: '4px' }}>🔒 CÓDIGO DE VERIFICAÇÃO (SHA-256):</div>
                    <div style={{ fontFamily: 'monospace', fontSize: '11px', wordBreak: 'break-all', background: 'white', padding: '8px', borderRadius: '6px', border: '1px solid #cce5cc' }}>{contrato.hash_assinatura}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '16px', textAlign: 'center' }}>
              <button onClick={baixarPDF} style={{ background: cor, color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                📄 Baixar PDF com Comprovante
              </button>
            </div>
          </div>
        ) : (
          <div style={{ background: '#FAEEDA', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '24px' }}>⏳</span>
            <div>
              <div style={{ fontWeight: '600', color: '#633806' }}>Assinatura pendente</div>
              <div style={{ fontSize: '13px', color: '#666' }}>Leia o contrato abaixo e assine digitalmente</div>
            </div>
          </div>
        )}

        {/* Conteúdo */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '40px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: '24px', lineHeight: '1.7', fontSize: '14px', color: '#333' }}
          dangerouslySetInnerHTML={{ __html: renderConteudo(contrato.conteudo_final) }} />

        {/* Área de assinatura */}
        {contrato.status !== 'assinado' && (
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 8px', fontSize: '16px', color: '#333' }}>✍️ Assinatura Digital</h3>
            <p style={{ color: '#666', fontSize: '13px', marginBottom: '20px' }}>
              Para assinar, preencha os dados abaixo e tire uma foto do seu RG ou CNH. Todos os dados serão registrados como prova legal.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', color: '#555', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Nome completo *</label>
                <input type="text" placeholder="Digite seu nome completo" value={nomeAssinante} onChange={e => setNomeAssinante(e.target.value)}
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '2px solid #ddd', fontSize: '15px', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ fontSize: '13px', color: '#555', fontWeight: '600', display: 'block', marginBottom: '6px' }}>CPF *</label>
                <input type="text" placeholder="000.000.000-00" value={cpfAssinante} onChange={e => setCpfAssinante(formatarCPF(e.target.value))}
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '2px solid #ddd', fontSize: '15px', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ fontSize: '13px', color: '#555', fontWeight: '600', display: 'block', marginBottom: '6px' }}>📸 Foto do documento (RG ou CNH) *</label>
                <input ref={inputFotoRef} type="file" accept="image/*" capture="environment" onChange={selecionarFoto} style={{ display: 'none' }} />

                {fotoPreview ? (
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img src={fotoPreview} alt="Documento" style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px', border: '2px solid #1D9E75', display: 'block' }} />
                    <button onClick={tirarFoto} style={{ marginTop: '8px', background: '#f0f0f0', color: '#333', border: 'none', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                      🔄 Tirar outra foto
                    </button>
                  </div>
                ) : (
                  <button onClick={tirarFoto}
                    style={{ width: '100%', background: '#f8f8f8', border: '2px dashed #ddd', borderRadius: '8px', padding: '24px', cursor: 'pointer', fontSize: '14px', color: '#666', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '36px' }}>📷</span>
                    <span style={{ fontWeight: '600' }}>Tirar foto do documento</span>
                    <span style={{ fontSize: '12px' }}>RG ou CNH — frente e verso na mesma foto</span>
                  </button>
                )}
              </div>

              <div style={{ background: '#fff3cd', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#856404' }}>
                ⚠️ Ao clicar em assinar, seu nome, CPF, IP do dispositivo, foto do documento e data/hora serão registrados permanentemente como prova da assinatura.
              </div>

              <button onClick={assinar} disabled={assinando || !nomeAssinante.trim() || !foto}
                style={{ width: '100%', background: assinando || !nomeAssinante.trim() || !foto ? '#ccc' : cor, color: 'white', border: 'none', borderRadius: '8px', padding: '14px', cursor: assinando || !nomeAssinante.trim() || !foto ? 'not-allowed' : 'pointer', fontWeight: '700', fontSize: '16px' }}>
                {assinando ? '⏳ Assinando...' : '✅ Assinar Contrato Digitalmente'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AssinarContrato;